import Vue from 'vue'

const state = {
    status: '',
}

const getters = {}

const actions = {
    /**
     * Preferences d'alerte d'un univers : utilisateurs, abonnements, seuils.
     * queries : { siteId }
     */
    alertPreferencesSiteRequest: async ({commit}, queries) => {
        return new Promise((resolve, reject) => {
            commit('alertPreferenceRequest')
            Vue.axios.get(`/api/alert-preferences/site/${queries.siteId}`)
                .then(result => {
                    commit('alertPreferenceSuccess')
                    resolve(result.data)
                })
                .catch(err => {
                    commit('alertPreferenceError');
                    reject(err)
                })
        })
    },

    /**
     * Abonnement d'un utilisateur a un univers.
     * queries : { siteId, userId, optin_sms, optin_mail }
     */
    alertPreferenceSubscriptionRequest: async ({commit}, queries) => {
        const payload = {};

        if (queries.optin_sms !== undefined) payload.optin_sms = queries.optin_sms;
        if (queries.optin_mail !== undefined) payload.optin_mail = queries.optin_mail;

        return new Promise((resolve, reject) => {
            commit('alertPreferenceRequest')
            Vue.axios.put(`/api/alert-preferences/site/${queries.siteId}/user/${queries.userId}`, payload)
                .then(result => {
                    commit('alertPreferenceSuccess')
                    resolve(result.data)
                })
                .catch(err => {
                    commit('alertPreferenceError');
                    reject(err)
                })
        })
    },

    /**
     * Seuils personnels d'un utilisateur sur les mesures d'un univers.
     * queries : { siteId, userId, thresholds: [{sensor_id, min, max, enabled}] }
     */
    alertPreferenceThresholdsRequest: async ({commit}, queries) => {
        return new Promise((resolve, reject) => {
            commit('alertPreferenceRequest')
            Vue.axios.put(
                `/api/alert-preferences/site/${queries.siteId}/user/${queries.userId}/thresholds`,
                {thresholds: queries.thresholds}
            )
                .then(result => {
                    commit('alertPreferenceSuccess')
                    resolve(result.data)
                })
                .catch(err => {
                    commit('alertPreferenceError');
                    reject(err)
                })
        })
    },

    /**
     * Mes propres abonnements, tous clients confondus.
     */
    alertPreferencesMineRequest: async ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('alertPreferenceRequest')
            Vue.axios.get('/api/alert-preferences/me')
                .then(result => {
                    commit('alertPreferenceSuccess')
                    resolve(result.data)
                })
                .catch(err => {
                    commit('alertPreferenceError');
                    reject(err)
                })
        })
    },

    /**
     * queries : { sites: [{site_id, optin_sms, optin_mail}] }
     */
    alertPreferencesMineSaveRequest: async ({commit}, queries) => {
        return new Promise((resolve, reject) => {
            commit('alertPreferenceRequest')
            Vue.axios.put('/api/alert-preferences/me', queries)
                .then(result => {
                    commit('alertPreferenceSuccess')
                    resolve(result.data)
                })
                .catch(err => {
                    commit('alertPreferenceError');
                    reject(err)
                })
        })
    },
}

const mutations = {
    alertPreferenceRequest: (state) => {
        state.status = 'loading';
    },
    alertPreferenceSuccess: (state) => {
        state.status = 'success';
    },
    alertPreferenceError: (state) => {
        state.status = 'error';
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}
